import React from 'react';
import PropTypes from 'prop-types';
import EthereumAddress from '@blockcatio/tabby-library/lib/components/EthereumAddress';

const RemovePaymentModal = ({ sender, destination, close }) => (
  <div className="remove-payment-modal">
    <h2>Remove Payment</h2>
    <p>This action removes the payment from your list.</p>
    <table>
      <tbody>
        <tr className="address-row">
          <td className="label">From:</td>
          <td className="address">
            <EthereumAddress address={sender} />
          </td>
        </tr>
        <tr className="address-row">
          <td className="label">To:</td>
          <td className="address">
            <EthereumAddress address={destination} />
          </td>
        </tr>
      </tbody>
    </table>
    <div className="actions">
      <button type="button" name="back" className="btn cancel" onClick={() => close(false)}>
        Back
      </button>
      <button type="button" name="continue" className="btn" onClick={() => close(true)}>
        Continue
      </button>
    </div>
  </div>
);

RemovePaymentModal.defaultProps = {
  close: () => null,
};

RemovePaymentModal.propTypes = {
  sender: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired,
  close: PropTypes.func,
};

export default RemovePaymentModal;



// WEBPACK FOOTER //
// ./src/components/RemovePaymentModal.js